import { memo } from "react";
import { Badge } from "@/shared/components/ui/badge";
import { RentalType } from "@/shared/types/enums";

const TYPE_LABEL: Record<RentalType, string> = {
  [RentalType.SUIT]: "Terno",
  [RentalType.GOWN]: "Beca",
};

interface RentalTypeBadgeProps {
  type: RentalType;
}

/**
 * Badge visual para `RentalType`. Centraliza o de-para PT-BR usado em
 * tabelas, modais e filtros.
 *
 * @example
 * <RentalTypeBadge type={RentalType.SUIT} />
 */
export const RentalTypeBadge = memo(function RentalTypeBadge({
  type,
}: RentalTypeBadgeProps) {
  return <Badge variant="outline">{TYPE_LABEL[type]}</Badge>;
});

export const RENTAL_TYPE_LABELS = TYPE_LABEL;
